import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Initialize i18next before the app renders.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* i18next (useSuspense) suspends while shell namespaces load. */}
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>
);
